import React, {useEffect, useState} from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale} from  "react-datepicker";
import {mk} from 'date-fns/locale';
import './DatePicerComponent.css'


export const DatePickerMonthComponent = ({selectedDate, onChange, placeholder}) => {
    registerLocale('mk', mk);

    return (
        <div>
            <DatePicker
                className="candidate_data"
                selected={selectedDate && new Date(selectedDate)}
                        onChange={onChange}
                        onYearChange={onChange}
                        onMonthChange={onChange}
                        dateFormat='MM.yyyy'
                        maxDate={new Date()}
                        showMonthYearPicker
                        showFullMonthYearPicker
                        showFourColumnMonthYearPicker
                        dropdownMode="select"
                        locale="mk"
                        placeholderText={placeholder}
                        popperClassName="date-picker"
            />
        </div>
    )
}





